import React, { useEffect, useState } from "react";
import AddTreatmentOne from "./components/AddTreatmentOne";
import baseUrl from "../../../../../api/baseUrl";
import { useDispatch } from "react-redux";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddIcon from "@mui/icons-material/Add";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PercentIcon from "@mui/icons-material/Percent";
import {
  setloadeActive,
  setloadeDeactive,
} from "../../../../../redux/loader/loaderActions";

function TreatmentAllList() {
  const [tretmentOpen, settretmentOpen] = useState(false);
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const [type, setType] = useState({});

  const getdata = () => {
    dispatch(setloadeActive());
    baseUrl
      .get("alltreatment/findAllTreatment")
      .then((response) => {
        dispatch(setloadeDeactive());
        setData(response.data.data);
      })
      .catch((error) => {
        dispatch(setloadeDeactive());
        console.log(error);
      });
  };

  useEffect(() => {
    getdata();
  }, [tretmentOpen]);

  const openModel = () => {
    settretmentOpen(!tretmentOpen);
    setType({});
  };

  const deactivateTreatment = (e: any) => {
    baseUrl
      .post("alltreatment/updateTreatmentStatus", e, { headers: { status: "false" } })
      .then((response) => getdata())
      .catch((error) => console.log(error));
  };

  const handleEdit = (e: any) => {
    settretmentOpen(!tretmentOpen);
    setType(e);
  };

  // Flatten data for display
  const flattenedData: any[] = [];
  data
    ?.filter((item: any) => item.status1 === true)
    ?.forEach((item: any) => {
      if (item?.type.length > 0) {
        item?.type
          ?.filter((t: any) => t.status2 === true)
          ?.forEach((typeItem: any) => {
            if (typeItem?.subType.length > 0) {
              typeItem?.subType
                ?.filter((s: any) => s.status3 === true)
                ?.forEach((subtype: any) => {
                  flattenedData.push({
                    treatment: item?.treatment,
                    type: typeItem?.treatment,
                    subType: subtype?.treatment,
                    price: subtype?.price,
                    materialCost: subtype?.materialCost,
                    doctorCommission: subtype?.doctorCommission,
                    editData: {
                      type: "subsub",
                      treatmentid: item?._id,
                      subId: typeItem?._id,
                      subsubId: subtype?._id,
                      treatment: subtype?.treatment,
                      price: subtype?.price,
                      materialCost: subtype?.materialCost,
                      doctorCommission: subtype?.doctorCommission,
                    },
                    deactivateData: {
                      type: "subsub",
                      mainId: item?._id,
                      subId: typeItem?._id,
                      subsubId: subtype?._id,
                    },
                  });
                });
            } else {
              flattenedData.push({
                treatment: item?.treatment,
                type: typeItem?.treatment,
                subType: "",
                price: typeItem?.price,
                materialCost: typeItem?.materialCost,
                doctorCommission: typeItem?.doctorCommission,
                editData: {
                  type: "sub",
                  treatmentid: item?._id,
                  subId: typeItem?._id,
                  treatment: typeItem?.treatment,
                  price: typeItem?.price,
                  materialCost: typeItem?.materialCost,
                  doctorCommission: typeItem?.doctorCommission,
                },
                deactivateData: {
                  type: "sub",
                  mainId: item?._id,
                  subId: typeItem?._id,
                },
              });
            }
          });
      } else {
        flattenedData.push({
          treatment: item?.treatment,
          type: "",
          subType: "",
          price: item?.price,
          materialCost: item?.materialCost,
          doctorCommission: item?.doctorCommission,
          editData: {
            type: "main",
            treatmentid: item?._id,
            treatment: item?.treatment,
            price: item?.price,
            materialCost: item?.materialCost,
            doctorCommission: item?.doctorCommission,
          },
          deactivateData: {
            type: "main",
            mainId: item?._id,
          },
        });
      }
    });

  return (
    <>
      {/* Header Card */}
      <div className="bg-white rounded-2xl shadow-lg shadow-slate-200/50 border border-slate-100 p-4 mb-4">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-primary to-primaryLight rounded-xl flex items-center justify-center">
              <MedicalServicesIcon className="text-white" sx={{ fontSize: 20 }} />
            </div>
            <div>
              <h3 className="text-lg font-bold text-slate-800">Treatment List</h3>
              <p className="text-sm text-slate-500">{flattenedData.length} treatments</p>
            </div>
          </div>
          <button
            onClick={() => openModel()}
            className="flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-primary to-primaryLight text-white rounded-xl hover:shadow-lg hover:shadow-primary/20 transition-all font-medium"
          >
            <AddIcon sx={{ fontSize: 20 }} />
            Add New
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white rounded-2xl shadow-lg shadow-slate-200/50 border border-slate-100 overflow-hidden">
        {/* Mobile Cards */}
        <div className="md:hidden p-4 space-y-3">
          {flattenedData.length === 0 ? (
            <div className="text-center py-12 text-slate-400">
              <MedicalServicesIcon sx={{ fontSize: 48 }} className="mb-2" />
              <p>No treatments found</p>
            </div>
          ) : (
            flattenedData.map((item: any, i: number) => (
              <div key={i} className="bg-slate-50 rounded-xl p-4 border border-slate-100">
                <div className="mb-3">
                  <p className="font-semibold text-slate-800">{item.treatment}</p>
                  {item.type && (
                    <p className="text-sm text-indigo-600">{item.type}</p>
                  )}
                  {item.subType && (
                    <p className="text-xs text-slate-500">{item.subType}</p>
                  )}
                </div>
                <div className="grid grid-cols-3 gap-2 mb-3">
                  <div className="bg-white rounded-lg p-2 text-center">
                    <p className="text-xs text-slate-500">Price</p>
                    <p className="font-semibold text-emerald-600">{item.price}</p>
                  </div>
                  <div className="bg-white rounded-lg p-2 text-center">
                    <p className="text-xs text-slate-500">Cost</p>
                    <p className="font-semibold text-slate-700">{item.materialCost || 0}</p>
                  </div>
                  <div className="bg-white rounded-lg p-2 text-center">
                    <p className="text-xs text-slate-500">Comm %</p>
                    <p className="font-semibold text-blue-600">{item.doctorCommission || 0}%</p>
                  </div>
                </div>
                <div className="flex gap-2 pt-3 border-t border-slate-200">
                  <button
                    onClick={() => handleEdit(item.editData)}
                    className="flex-1 flex items-center justify-center gap-1 px-3 py-2 bg-indigo-50 text-indigo-600 rounded-lg hover:bg-indigo-100 transition-colors text-sm font-medium"
                  >
                    <BorderColorIcon sx={{ fontSize: 18 }} />
                    Edit
                  </button>
                  <button
                    onClick={() => deactivateTreatment(item.deactivateData)}
                    className="p-2 bg-red-50 text-red-500 rounded-lg hover:bg-red-100 transition-colors"
                  >
                    <DeleteOutlineIcon sx={{ fontSize: 18 }} />
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Desktop Table */}
        <div className="hidden md:block overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="bg-slate-50/80">
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">
                  Treatment
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">
                  Type
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">
                  Sub Type
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">
                  <div className="flex items-center gap-1">
                    <AttachMoneyIcon sx={{ fontSize: 16 }} />
                    Price
                  </div>
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">
                  Cost
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">
                  <div className="flex items-center gap-1">
                    <PercentIcon sx={{ fontSize: 14 }} />
                    Commission
                  </div>
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {flattenedData.length === 0 ? (
                <tr>
                  <td colSpan={7} className="px-6 py-12 text-center text-slate-400">
                    <MedicalServicesIcon sx={{ fontSize: 48 }} className="mb-2" />
                    <p>No treatments found</p>
                  </td>
                </tr>
              ) : (
                flattenedData.map((item: any, i: number) => (
                  <tr key={i} className="hover:bg-slate-50/50 transition-colors">
                    <td className="px-6 py-3">
                      <span className="font-medium text-slate-800">{item.treatment}</span>
                    </td>
                    <td className="px-6 py-3">
                      {item.type ? (
                        <span className="px-2.5 py-1 bg-indigo-50 text-indigo-600 rounded-full text-xs font-medium">
                          {item.type}
                        </span>
                      ) : (
                        <span className="text-slate-400">-</span>
                      )}
                    </td>
                    <td className="px-6 py-3">
                      {item.subType ? (
                        <span className="px-2.5 py-1 bg-purple-50 text-purple-600 rounded-full text-xs font-medium">
                          {item.subType}
                        </span>
                      ) : (
                        <span className="text-slate-400">-</span>
                      )}
                    </td>
                    <td className="px-6 py-3">
                      <span className="font-semibold text-emerald-600">{item.price}</span>
                    </td>
                    <td className="px-6 py-3 text-sm text-slate-600">
                      {item.materialCost || 0}
                    </td>
                    <td className="px-6 py-3">
                      <span className="px-2.5 py-1 bg-blue-50 text-blue-600 rounded-full text-xs font-medium">
                        {item.doctorCommission || 0}%
                      </span>
                    </td>
                    <td className="px-6 py-3">
                      <div className="flex items-center gap-2">
                        <button
                          onClick={() => handleEdit(item.editData)}
                          className="p-2 rounded-lg bg-indigo-50 text-indigo-600 hover:bg-indigo-100 transition-colors"
                          title="Edit"
                        >
                          <BorderColorIcon sx={{ fontSize: 18 }} />
                        </button>
                        <button
                          onClick={() => deactivateTreatment(item.deactivateData)}
                          className="p-2 rounded-lg bg-red-50 text-red-500 hover:bg-red-100 transition-colors"
                          title="Deactivate"
                        >
                          <DeleteOutlineIcon sx={{ fontSize: 18 }} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {tretmentOpen && <AddTreatmentOne type={type} close={settretmentOpen} />}
    </>
  );
}

export default TreatmentAllList;
